function formatTime(timeInSec, includeHours) {
    const hours = Math.floor(timeInSec/3600);
    const mins = Math.floor(timeInSec/60);
    const secs = timeInSec - mins*60;

    let timeStr = (mins%60).toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0');

    if (includeHours) {
        timeStr = hours.toString().padStart(2, '0') + ':' + timeStr;
    }

    return timeStr;
}

app
    .filter('sgSessionTimer', function () {
        return formatTime;
    })
    .directive('exerciseTimer', function ($window, $interval) {
        return {
            restrict: 'E',
            scope: {
                onPause: '=',
                onFinishDialog: '=',
                isSessionFinished: '=',
                perceivedExertion: '=',
                timeElapsed: '='
            },
            // TODO: actually, this directive should be only concerned with timer functionality.
            // Program completion should be handled on program-detail.js level (or in another separate module)
            template:
                '<span class="sg-timer" ng-if="showTimer" ng-class="mode">' +
                    '<span class="sg-timer-buttons">'+
                        '<a href="#play" ng-click="handlePlay($event)" class="sg-timer-btn" ng-if="state === \'pristine\' || state === \'paused\'">' +
                            '<i class="fa fa-play"></i>'+
                            '<span ng-if="mode === \'global\' && state === \'pristine\'">{{trans.start}}</span>' +
                            '<span ng-if="mode === \'global\' && state === \'paused\'">{{trans.resume}}</span>' +
                        '</a>' +
                        '<a href="#pause" ng-click="handlePause($event)" class="sg-timer-btn" ng-if="state === \'playing\'">' +
                            '<i class="fa fa-pause"></i>'+
                            '<span ng-if="mode === \'global\'">{{trans.inProgress}}</span>' +
                        '</a>' +
                        '<a href="#reset" ng-click="handleReset($event)" class="sg-timer-btn" ng-if="mode !== \'global\' && state === \'finished\'">' +
                            '<i class="fa fa-undo"></i>'+
                        '</a>' +
                        '<span class="sg-timer-btn" ng-if="mode === \'global\' && state === \'finished\'">' +
                            '<i class="fa fa-check"></i>'+
                            '<span ng-if="mode === \'global\'">{{trans.recorded}}</span>' +
                        '</span>' +
                    '</span>'+
                    '<span class="sg-timer-elapsed">{{ timeElapsed | sgSessionTimer:(mode === \'global\') }}</span>' +
                    '<span class="sg-timer-complete" ng-if="mode === \'global\'">'+
                        '<a href="#finish" class="sg-timer-btn-finish" ng-click="handleFinishDialog($event)" ng-if="state !== \'pristine\' && state !== \'finished\'">{{trans.finish}}</a>' +
                        '<a href="#edit-time" class="sg-timer-btn-edit" ng-if="state === \'finished\'" ng-click="handleFinishDialog($event)">{{trans.editTime}}</a>' +
                    '</span>' +
                '</span>',
            link: function ($scope, $element, attrs) {
                const translationsDefault = {
                    start: 'Start',
                    finish: 'Finish',
                    inProgress: 'In progress',
                    resume: 'Resume',
                    reset: 'Reset',
                    recorded: 'Recorded',
                    editTime: 'Edit time',
                };
                let translationsArg;
                try {
                    translationsArg = JSON.parse(attrs.translations || '{}');
                } catch (e) {
                    translationsArg = {};
                }
                $scope.trans = Object.assign({}, translationsDefault, translationsArg);
                $scope.timeElapsed = $scope.timeElapsed || 0;
                $scope.showTimer = true;
                $scope.intervalRef = null;
                $scope.state = $scope.timeElapsed > 0 ? 'paused' : 'pristine'; // pristine, playing, paused, finished
                $scope.mode = attrs.mode || 'default';
                $scope.timeDelta = parseInt(attrs.direction || 1, 10) > 0 ? 1 : -1;
                $scope.isShowingFinishDialog = false;


                const originalTime = $scope.timeElapsed;

                const beforeUnloadHandler = function(event) {
                    event.preventDefault();
                    event.returnValue = '';
                };

                $scope.handlePlay = function (event) {
                    $scope.state = 'playing';
                    $scope.intervalRef = $interval(function () {
                        if ($scope.timeElapsed === 0 && $scope.timeDelta < 0) {
                            $interval.cancel($scope.intervalRef);
                            $scope.state = 'finished';
                            return;
                        }

                        $scope.timeElapsed += $scope.timeDelta;
                    }, 1000);

                    event.preventDefault();

                    window.addEventListener('beforeunload', beforeUnloadHandler);
                };
                $scope.handlePause = function (event) {
                    $scope.state = 'paused';
                    $interval.cancel($scope.intervalRef);

                    event.preventDefault();

                    $scope.onPause($scope.timeElapsed, $scope.perceivedExertion);
                    window.removeEventListener('beforeunload', beforeUnloadHandler);
                };
                $scope.handleReset = function (event) {
                    $scope.state = 'pristine';
                    $scope.timeElapsed = originalTime;

                    event.preventDefault();
                };
                $scope.handleFinishDialog = function (event) {
                    $scope.isSessionFinished = false;
                    $scope.isShowingFinishDialog = true;
                    $scope.handlePause(event);
                    event.preventDefault();
                    $scope.onFinishDialog($scope.timeElapsed, $scope.perceivedExertion);
                };
                $scope.handleFinish = function() {
                    $scope.state = 'finished';
                };

                $scope.$watch('isSessionFinished', function (newValue) {
                    if (newValue === true) {
                        $scope.handleFinish();
                    }
                });
            }
        };
    });
